import React from "react";
import { Reveal, MaskLines, SectionMark } from "./ui/Primitives";

const steps = [
  {
    title: "שיחת אפיון",
    description:
      "מתחילים בהבנה מעמיקה של העסק, המטרות והקהל שלכם, ומגדירים יעדים ברורים ומדידים.",
  },
  {
    title: "מחקר ואסטרטגיה",
    description:
      "מנתחים את השוק, המתחרים וההזדמנויות, ובונים תוכנית פעולה מותאמת אישית.",
  },
  {
    title: "עיצוב ופיתוח",
    description:
      "מעצבים ומפתחים את הפתרון בסטנדרטים הגבוהים ביותר, עם דגש על חוויית משתמש.",
  },
  {
    title: "השקה ופרסום",
    description:
      "עולים לאוויר ומשיקים קמפיינים ממוקדים שמתחילים להניב תוצאות מהיום הראשון.",
  },
  {
    title: "אופטימיזציה מתמדת",
    description:
      "מנטרים, מנתחים ומשפרים באופן שוטף כדי להבטיח צמיחה עקבית ומקסום תוצאות.",
  },
];

const Process: React.FC = () => (
  <section id="process" className="border-t border-[var(--line)] bg-ink-2 py-24 lg:py-32">
    <div className="shell">
      <Reveal>
        <SectionMark label="איך זה עובד" />
      </Reveal>

      <MaskLines
        as="h2"
        className="t-h1 mb-16 max-w-[16ch] text-fg"
        lines={["חמישה שלבים", "מהשיחה הראשונה לתוצאה"]}
      />

      {/* The sequence itself is the information here, so the numbers earn their
          place: they are the order of work, not decoration. */}
      <ol className="grid gap-px bg-[var(--line)] sm:grid-cols-2 lg:grid-cols-5">
        {steps.map((step, i) => (
          <Reveal as="li" key={step.title} delay={i * 80} className="bg-ink-2">
            <div className="flex h-full flex-col p-6">
              <span className="t-data mb-5 text-signal" dir="ltr">
                {String(i + 1).padStart(2, "0")}
              </span>
              <h3 className="t-h3 mb-2.5 text-fg">{step.title}</h3>
              <p className="text-sm leading-relaxed text-fg-2">{step.description}</p>
            </div>
          </Reveal>
        ))}
      </ol>
    </div>
  </section>
);

export default Process;
